export default function CustomOption(props) {
  const { list, currentOption, setCurrentOption } = props

  return (
    <div className='customOption'>
      {
        list.map((item,index) => {
          if (index !== 1) {
            return (
              <div className='singleOption' onClick={() => setCurrentOption(item)} key={index}>
                <div className={currentOption === item ? 'optionCircle optionCurrent' : 'optionCircle'}><div /></div>
                <div className='optionValue'>{item}</div>
              </div>
            )
          }
          else {
            return (
              <div className='singleOption disabledOption' key={index}>
                <div className='optionCircle'><div /></div>
                <div className='optionValue'>{item}</div>
              </div>
            )
          }
        })
      }
    </div>
  )
}